/**
 * Screen zero. Not a decision — a promise: a few questions, one at a time,
 * and nothing here is permanent. It is the one screen with no Back, so it is
 * rendered outside `StepFrame` (spec §2.2).
 */
import { ArrowRight } from "lucide-react";
import { STEP_COPY } from "../../../lib/brandSetup/steps";
import { StepHeader } from "../StepFrame";

export function WelcomeStep(props: {
  brandName: string;
  /** Where a saved draft left off — turns Start into "Pick up where you left off". */
  resume: { n: number; total: number } | null;
  /** Why the walk is picking up somewhere other than where it stopped (a read
   *  that was interrupted by the refresh). One sentence, or nothing. */
  note?: string | null;
  onStart: () => void;
  onStartOver: () => void;
}): React.JSX.Element {
  const { brandName, resume, note } = props;
  const copy = STEP_COPY.welcome;
  return (
    <div style={{ display: "grid", gap: 28 }}>
      <StepHeader chapter="Welcome" n={null} total={null} headline={copy.headline(brandName)} why={copy.why} />
      <div style={{ display: "grid", gap: 12, justifyItems: "start" }}>
        <button
          type="button"
          autoFocus
          onClick={props.onStart}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
            padding: "16px 32px",
            borderRadius: 16,
            border: "none",
            fontWeight: 800,
            fontSize: 15.5,
            fontFamily: "inherit",
            color: "#000",
            background: "linear-gradient(135deg,#FFD500,#FFA500)",
            boxShadow: "0 4px 16px rgba(255,213,0,.30)",
            cursor: "pointer",
          }}
        >
          <ArrowRight size={16} />
          {resume ? "Pick up where you left off" : "Start"}
          <span aria-hidden style={{ fontSize: 13, opacity: 0.5 }}>↵</span>
        </button>
        {resume && (
          <div style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 13, color: "var(--ql-fg-subtle)", flexWrap: "wrap" }}>
            <span>{note ?? `You were on step ${resume.n} of ${resume.total}.`}</span>
            <button
              type="button"
              onClick={props.onStartOver}
              style={{
                border: "none",
                background: "transparent",
                color: "var(--ql-fg-muted)",
                fontSize: 13,
                fontFamily: "inherit",
                textDecoration: "underline",
                cursor: "pointer",
                padding: 0,
              }}
            >
              Start over
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
